/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Popper from "@mui/material/Popper";
import Button from "@mui/material/Button";
import { useNitroStore } from "../../store/Store";
import { useIsComponentMounted } from "../../hooks/useIsComponentMounted";
import SearchClear from "../../svg/searchClear.svg?react";
import { useNitroCAStore } from "../../store/CompetitiveAnalysisStore";

interface HoverButtonProps {
  active?: boolean;
  disabled?: boolean;
  ref?: React.MutableRefObject<any>;
  style?: React.CSSProperties;
}
const HoverButton = styled.div<HoverButtonProps>``;
const radius = "32.5px";

const getBackgroundColor = (isOpen?: boolean, isDisabled?: boolean) => {
  if (isDisabled) return "#F3F4F6";
  if (isOpen === undefined || isOpen) return "white";
  return "#EDEDED";
};

const getBorder = (isOpen?: boolean, isFirst?: boolean, isLast?: boolean) => {
  if (isOpen) return `${radius} ${radius} ${radius} ${radius}`;
  if (isFirst && isLast) return `${radius} ${radius} ${radius} ${radius}`;
  if (isFirst) return `${radius}  0 0 ${radius}`;
  if (isLast) return `0 ${radius} ${radius} 0`;

  return "0 0 0 0";
};

const getLayerStyle = (
  isOpen?: boolean,
  isDisabled?: boolean,
  isFirst?: boolean,
  isLast?: boolean,
) => {
  let borderRadius = "";
  let padding = isOpen ? "0px 3px 0px 3px" : "";

  if (isFirst) {
    borderRadius = `${radius}  0 0 ${radius}`;
    if (isOpen) padding = "0px 3px 0px 0px";
  }
  if (isLast) {
    borderRadius = `0 ${radius} ${radius} 0`;
    if (isOpen) padding = "0px 0px 0px 0px";
  }
  if (isFirst && isLast) {
    borderRadius = `${radius} ${radius} ${radius} ${radius}`;
    if (isOpen) padding = "0px 3px 0px 3px";
  }
  if (isDisabled) {
    return {
      padding,
      borderRadius,
      backgroundColor: "#D9D9D9",
    };
  }

  if (!isDisabled && isFirst) {
    return {
      padding,
      borderRadius,
      background: "linear-gradient(90deg, #D9D9D9 50%, #EDEDED 50%)",
    };
  }

  if (!isDisabled && isLast) {
    return {
      padding,
      borderRadius,
      background: "linear-gradient(90deg, #EDEDED 50%, rgb(0,0,0,0) 50%)",
    };
  }

  if (!isDisabled) {
    return {
      padding,
      borderRadius,
      background: "#EDEDED",
    };
  }

  return {};
};

const Insides = ({
  label,
  placeholder,
  value,
  type,
  children,
  disabled,
  selected,
  select,
  zIndex,
  className,
  clear,
}: {
  label: string;
  placeholder: string;
  value: string;
  type: "popup" | "filter";
  children?: React.ReactElement | React.ReactElement[] | React.ReactNode;
  disabled?: boolean;
  selected?: boolean;
  select?: (value: boolean) => void;
  zIndex?: number;
  className?: string;
  clear: () => void;
}) => {
  const [hideAllPanels, clearLocations, setMultiLocationDestinations] =
    useNitroStore((state) => [
      state.hideAllPanels,
      state.clearLocations,
      state.setMultiLocationDestinations,
    ]);
  const [setDisplayFreightDetailsPanel] = useNitroCAStore((state) => [
    state.setDisplayRailFreightDetailsPanel,
  ]);
  const [showChildren, setShowChildren] = useState(false);
  useEffect(() => {
    if (type === "filter" && selected) {
      setShowChildren(true);
    } else {
      setShowChildren(false);
    }
  }, [type, selected, label]);
  return (
    <div
      style={{
        zIndex,
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        padding: "0px 10px",
        paddingRight: 10,
      }}
    >
      <div
        style={{
          height: "100%",
          width: "100%",
          paddingLeft: 15,
          zIndex: zIndex || 20,
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          cursor: disabled ? "auto" : "pointer",
          textOverflow: "ellipsis",
          opacity: disabled ? 0.7 : 1,
        }}
        onClick={() => {
          if (disabled) return;
          if (select) select(true);
        }}
      >
        <div
          className={disabled ? "filterChildLabelDisabled" : "filterChildLabel"}
          style={{ fontSize: selected ? 12 : 13 }}
        >
          {label}
        </div>

        <div
          className={`${className}`}
          style={{
            paddingBottom: 4,
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            opacity: "inherit",
          }}
        >
          {!showChildren && value && (
            <div
              className={
                disabled ? "filterChildContentDisabled" : "filterChildContent"
              }
              style={{ fontSize: selected ? 12 : 13 }}
            >
              {value}
            </div>
          )}
          {!showChildren && !value && (
            <div
              className={
                disabled
                  ? "filterChildPlaceholderDisabled"
                  : "filterChildPlaceholder"
              }
              style={{
                fontSize: selected ? 12 : 13,
                fontWeight: type === "filter" && !selected ? 500 : undefined,
              }}
            >
              {placeholder}
            </div>
          )}
          {showChildren && (
            <div
              style={{
                width: "100%",
                paddingRight: 22,
              }}
            >
              {children}
            </div>
          )}
        </div>
      </div>
      {label !== "WHEN" && !selected && value && !disabled && (
        <Button
          onMouseDown={(event) => {
            event.preventDefault();
            event.stopPropagation();
          }}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            clear();
            setMultiLocationDestinations([]);
            setDisplayFreightDetailsPanel(false);
            hideAllPanels();
            clearLocations();
          }}
          style={{
            height: 23,
            width: 23,
            minWidth: 23,
            top: 12,
            padding: 0,
            borderRadius: "50%",
            backgroundColor: "transparent",
            boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.25)",
          }}
        >
          <SearchClear style={{ height: 23, width: 23 }} />
        </Button>
      )}
    </div>
  );
};

// TODO: remove search adornment stuff
const FilterChild = ({
  label,
  placeholder,
  value,
  type,
  children,
  disabled,
  selected,
  select,
  first,
  last,
  property,
  zIndex,
  inFocus,
  className,
  clear,
}: {
  label: string;
  placeholder: string;
  value: string;
  type: "popup" | "filter";
  children?: React.ReactElement | React.ReactElement[] | React.ReactNode;
  disabled?: boolean;
  selected?: boolean;
  select?: (value: boolean) => void;
  first?: boolean;
  last?: boolean;
  property: string;
  zIndex?: number;
  inFocus?: boolean;
  className?: string;
  clear: () => void;
}) => {
  const inputRef = useRef<any | null>(null);
  const isComponentMounted = useIsComponentMounted();

  return (
    <ClickAwayListener
      key={property}
      onClickAway={() => {
        if (!isComponentMounted) return;
        if (selected && select) {
          select(false);
        }
      }}
    >
      <div
        className="filterChild"
        style={{
          ...getLayerStyle(selected, disabled, first, last),
        }}
      >
        {type === "popup" && children && (
          <Popper
            style={{
              position: "fixed",
              top: 42,
              left: last
                ? undefined
                : inputRef.current?.getBoundingClientRect().left,
              right: last
                ? window.innerWidth -
                  (inputRef.current?.getBoundingClientRect().right || 0)
                : undefined,
              zIndex: 26,
              minWidth: inputRef.current?.clientWidth,
              backgroundColor: "white",
              borderRadius: 30,
              boxShadow: "0 2px 8px 2px rgb(0 0 0/0.5)",
            }}
            open={selected || false}
          >
            <div>{children}</div>
          </Popper>
        )}

        {inFocus && (
          <div
            style={{
              position: "fixed",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              backgroundColor: "rgba(15, 44, 82, 0.5)", // Opaque background when comp analysis is open and no product selected
              zIndex: 21,
            }}
          />
        )}

        <HoverButton
          id="who-where-when-filter"
          disabled={disabled}
          ref={inputRef}
          style={{
            position: "relative",
            backgroundColor: getBackgroundColor(selected, disabled),
            borderRadius: getBorder(selected, first, last),
            zIndex: selected ? zIndex || 100 : 20, // Show on top of other items if selected
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            boxShadow: selected
              ? "0px 4px 6px 0px rgba(15, 44, 82, 0.25)"
              : undefined,
          }}
        >
          <div
            style={{
              height: "100%",
              display: "flex",
            }}
          >
            <Insides
              label={label}
              placeholder={placeholder}
              value={value}
              type={type}
              disabled={disabled}
              selected={selected}
              select={select}
              zIndex={zIndex}
              className={className}
              clear={clear}
            >
              {children}
            </Insides>
          </div>
        </HoverButton>
      </div>
    </ClickAwayListener>
  );
};

export default FilterChild;
